import {
  Modal,
  Box,
  Typography,
  TextField,
  Fade,
  Backdrop,
  Grid,
} from "@material-ui/core";
import { Loader2 } from "lucide-react";
import { useState } from "react";
import api from "../../services/api";
import { makeStyles } from "@material-ui/core/styles";
import { Button as ShadcnButton } from "../ui/button";

const useStyles = makeStyles((theme) => ({
  customButton: {
    color: "#3900DB",
    width: "200px",
    height: "10px",
    fontWeight: "400",
    fontSize: "14px",
    textAlign: "center",
    textDecoration: "underline",
    textTransform: "none",
  },
  gridContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(2),
  },
}));

const EsqueciSenhaButton = () => {
  const [showModal, setShowModal] = useState(false);
  const [usuarioColaborador, setUsuarioColaborador] = useState("");
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const handleButtonClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setUsuarioColaborador("");
    setShowModal(false);
  };

  const handleInputChange = (event) => {
    setUsuarioColaborador(event.target.value);
  };

  const handleEnviarEmail = async () => {
    setLoading(true);
  
    try {
      await api.post(
        "/forgot-password",
        { usuario_colaborador: usuarioColaborador },
        {
          headers: { "content-type": "application/json" },
        }
      );
  
      alert(
        `Um e-mail foi enviado para o usuário ${usuarioColaborador} com instruções para redefinir sua senha.`
      );
      handleCloseModal();
    } catch (err) {
      if (err.response && err.response.data) {
        window.alert(err.response.data.message || "Erro ao enviar o e-mail. Tente novamente.");
      } else {
        window.alert("Usuário não encontrado ou inativo, tente novamente");
      }
  
      console.log(err);
      handleCloseModal();
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div>
      <Grid container className={classes.gridContainer}></Grid>
      <ShadcnButton variant="link" type="button" onClick={handleButtonClick}>
        Esqueci minha senha
      </ShadcnButton>

      <Modal
        open={showModal}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Fade in={showModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              backgroundColor: "white",
              boxShadow: 4,
              width: 500,
              height: 200,
              transform: "translate(-50%, -50%)",
              padding: "1rem",
              borderRadius: ".5rem",
            }}
          >
            <Typography variant="h5" gutterBottom>
              Redefinir Senha
            </Typography>
            <TextField
              fullWidth
              label="Digite seu usuário"
              type="text"
              value={usuarioColaborador}
              onChange={handleInputChange}
              variant="outlined"
              margin="normal"
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
                gap: "1rem",
                marginTop: ".5rem",
              }}
            >
              <ShadcnButton
                variant="destructive"
            
                onClick={handleCloseModal}
              >
                Cancelar
              </ShadcnButton>
              <ShadcnButton
                disabled={loading}
                className={loading ? "disabled:bg-zinc-400" : ""}
                onClick={handleEnviarEmail}
              >
                {loading ? (
                  <>
                    <Loader2 className="animate-spin" />
                  </>
                ) : (
                  "Enviar e-mail"
                )}
              </ShadcnButton>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default EsqueciSenhaButton;
